export {default as DashboardDetails } from './DashboardDetails';